<template>

    <div>

        <v-row>
          <v-col cols="4">
            <v-alert dense text type="error">
              {{ counter_faturas }} faturas de internet
            </v-alert>
          </v-col>
          <v-col cols="4">
            <v-alert dense text type="success">
              {{ counter_faturas_integradas }} faturas de internet integradas
            </v-alert>
          </v-col>
          <v-col cols="4">
            <v-btn color="primary" @click="compels()" block>Integração em Massa</v-btn>
          </v-col>
        </v-row>

        <v-simple-table>
            <thead>
                <tr>
                <th>Nome</th>
                <th>Descrição</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th>Situação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in current" :key="item.id">
                <td>{{ item.clientName }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.expires | formatDate }}</td>
                <td>R$ {{ item.value | formatMoney }}</td>
                <td><v-chip :color="colorCompels(item.compelsId)" small>{{ item.compelsId | formatCompels }}</v-chip></td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-dialog v-model="dialog_loading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Por favor aguarde
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

    </div>
    
</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    current: [],
    counter_faturas: 0,
    counter_faturas_integradas: 0,
    dialog_loading: false
  }),
  created: function() {
    this.listMonth();
  },
  methods: {
    listMonth: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/fatura/month/internet", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.current = response.data;
        me.counter_faturas = response.data.length;
        for(var c=0;c<response.data.length;c++){
            var fatura = response.data[c];
            if(fatura.compelsId!==null){
                me.counter_faturas_integradas++;
            }
        }
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar faturamentos!");
      });
    },
    compels: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/fatura/compels/internet", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        console.log(response);
        //me.current = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar start!");
      });
    },
    colorCompels: function(val){
      var ret = "error";
      if(val!==null){
        ret = "success";
      }
      return ret;
    }
  },
  filters:{
    formatCompels: function(val){
      var ret = "Pendente";
      if(val!==null){
        ret = "Integrado";
      }
      return ret;
    }
  }
    
}
</script>